import Vue from 'vue';
import Router from 'vue-router';
import Home from './../views/HomeView.vue';
import Login from './../views/LoginView.vue';
import Users from "./../views/UsersView.vue";
import Clients from "./../views/ClientsView.vue";
import Tasks from "./../views/TasksView";
import Preguntas from "./../views/QAsView";
import Reportes from "./../views/ReportesView";
import Test from "./../views/Test";

import { TokenService } from './../services/storage.service'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/home/:filter?',
            name: 'home',
            component: Home,

        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                public: true,
                onlyWhenLoggedOut: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: Users
        },
        {
            path: '/clients',
            name: 'clients',
            component: Clients
        },
        {
            path: '/tasks',
            name: 'tasks',
            component: Tasks
        },
        {
            path: '/preguntas',
            name: 'preguntas',
            component: Preguntas
        },
        {
            path: '/reportes',
            name: 'reportes',
            component: Reportes
        }
    ]
})

/*
router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public)
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
    const loggedIn = !!TokenService.getToken();
  
    if (!isPublic && !loggedIn) {
      return next({
        path:'/login',
        query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
      });
    }
  
    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
      return next('/')
    }
  
    next();
  })
  
  */
export default router;